import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const numberValidator = ({ requiredError, min, max, } = {}) => {
    let validator = z.number({
        error: createErrorHandler(requiredError),
    });
    if (min) {
        validator = validator.min(min.value, min.error);
    }
    if (max) {
        validator = validator.max(max.value, max.error);
    }
    return validator;
};
